import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/pages/main'
import About from '@/pages/about'
import Contact from '@/pages/contact'
import ErrorPage from '@/pages/error/errorPage'

Vue.use(Router)

// 定义路由
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      meta: { requiresAuth: false }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: { requiresAuth: false }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: { requiresAuth: false }
    },
    {
      path: '*',
      component: ErrorPage
    }
  ]
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js